/** @jsxImportSource @compiled/react */
import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- React must be in scope for JSX in Jest
void React;

import { defineMessages, useIntl } from 'react-intl';
import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { SpaceContributorsList } from './SpaceContributorsList.tsx';

const i18n = defineMessages({
	pageTitle: {
		id: 'space-contributors.page.title',
		defaultMessage: 'Contributors',
		description: 'Page title for the space contributors page',
	},
});

export interface SpaceContributorsProps {
	spaceKey: string;
}

const styles = cssMap({
	page: {
		maxWidth: '1200px',
		margin: '0 auto',
		paddingBlock: token('space.400'),
		paddingInline: token('space.400'),
		// @ts-expect-error -- containerType is valid CSS but not typed in cssMap
		containerType: 'inline-size',
	},
});

export const SpaceContributors = ({ spaceKey }: SpaceContributorsProps) => {
	const intl = useIntl();

	return (
		<Box xcss={styles.page} testId="space-contributors-page">
			<Stack space="space.300">
				<Heading size="large">{intl.formatMessage(i18n.pageTitle)}</Heading>
				<SpaceContributorsList spaceKey={spaceKey} />
			</Stack>
		</Box>
	);
};
